import { Component, Prop,h, Host } from '@stencil/core';

@Component({
    tag: 'arrow-down-icon',
    shadow: false
})
export class ArrowDownIcon {

    @Prop() svgStyle: any = {};
    @Prop() width: number = 12;
    @Prop() height: number = 12;

    render() {
        return (
            <Host aria-hidden="true">
                <svg style={this.svgStyle} width={this.width} height={this.height} viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <slot />
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g fill-rule="nonzero" fill="currentColor">
                            <path d="M4.75105133,11.1796228 C4.41631622,11.5143579 4.41631622,12.0570707 4.75105133,12.3918058 C5.08578644,12.7265409 5.62849928,12.7265409 5.96323438,12.3918058 L10.2489487,8.10609153 C10.5836838,7.77135642 10.5836838,7.22864358 10.2489487,6.89390847 L5.96323438,2.60819419 C5.62849928,2.27345908 5.08578644,2.27345908 4.75105133,2.60819419 C4.41631622,2.94292929 4.41631622,3.48564213 4.75105133,3.82037724 L8.43067409,7.5 L4.75105133,11.1796228 Z" transform="translate(7.500000, 7.500000) rotate(-270.000000) translate(-7.500000, -7.500000) "></path>
                        </g>
                    </g>
                </svg>
            </Host>
        );
    }

}

